module.exports = __webpack_public_path__ + "img/tda-logo.659544bd.svg";